// @ts-check
import React from 'react';
import { injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import DataBrowserGroups from './DataBrowserGroups';
import DataBrowserSearchResult from './DataBrowserSearchResult';

/**
 * @typedef Props
 * @property {object} dataset
 * @property {object} mapInstance
 * @property {object} currentMetadataSelection
 * @property {object[]} openedGroup
 * @property {function} onSetOpenedGroup
 * @property {string} searchText
 * @property {import('react-intl').intlShape} intl
 *
 * @extends {React.Component<Props>}
 */
class DataBrowserContent extends React.Component {
    constructor(props, context) {
        super(props, context);
    }

    render() {
        const {
            dataset,
            mapInstance,
            currentMetadataSelection,
            openedGroups,
            onSetOpenedGroup,
            searchText,
        } = this.props;

        if (!dataset) {
            return null;
        }

        if (searchText) {
            return (
                <DataBrowserSearchResult
                    dataset={dataset}
                    mapInstance={mapInstance}
                    currentMetadataSelection={currentMetadataSelection}
                    searchText={searchText}
                />
            );
        }

        return (
            <DataBrowserGroups
                dataset={dataset}
                mapInstance={mapInstance}
                currentMetadataSelection={currentMetadataSelection}
                openedGroups={openedGroups}
                onSetOpenedGroup={onSetOpenedGroup}
            />
        );
    }
}

DataBrowserContent.propTypes = {
    dataset: PropTypes.object.isRequired,
    mapInstance: PropTypes.object.isRequired,
    currentMetadataSelection: PropTypes.object.isRequired,
    openedGroups: PropTypes.array,
    onSetOpenedGroup: PropTypes.func.isRequired,
    searchText: PropTypes.string,
    intl: PropTypes.object.isRequired,
};

DataBrowserContent.defaultProps = {
    openedGroups: [],
    searchText: '',
};

export default injectIntl(DataBrowserContent);
